import React from "react";

const Footer = () => {
  return (
    <div className="w-full h-20 flex items-center justify-center">
      <p>©2024. All rights reserved by Masum Ahmed</p>
    </div>
  );
};

export default Footer;
